module.exports = __webpack_public_path__ + "static/media/fidweb-wink-updates_optimized.dd609283.png";